export const SETTINGS_SCREEN_IDS = {
  ROOT: "settings-root",
  SECTION: "settings-section",
  TRAINING_PROFILE_MENU: "training-profile-menu",
  TRAINING_PROFILE_SECTION: "training-profile-section",
};

export const EXECUTION_SETTINGS_ORIGIN = "active-execution";
export const WORKOUT_PREFERENCES_SECTION_ID = "workoutPreferences";

const SETTINGS_SECTION_IDS = new Set([
  "account",
  "aiCoaching",
  WORKOUT_PREFERENCES_SECTION_ID,
  "interface",
]);

export function createExecutionWorkoutPreferencesLocation(executionId) {
  const normalizedExecutionId = String(executionId || "").trim();
  if (!normalizedExecutionId) {
    throw new Error("An execution id is required to open Workout Preferences.");
  }

  const returnTo = `/train/session/${encodeURIComponent(normalizedExecutionId)}`;
  return {
    pathname: "/",
    search: `?settings=${WORKOUT_PREFERENCES_SECTION_ID}`,
    state: {
      settingsOrigin: EXECUTION_SETTINGS_ORIGIN,
      returnTo,
    },
  };
}

export function resolveExecutionSettingsReturnTo(state) {
  if (state?.settingsOrigin !== EXECUTION_SETTINGS_ORIGIN) return null;
  const returnTo = typeof state?.returnTo === "string" ? state.returnTo : "";
  return /^\/train\/session\/[^/?#]+$/.test(returnTo) ? returnTo : null;
}

export function createScreen(id, params = {}) {
  return { id, params };
}

export function createRootNavigationStack() {
  return [createScreen(SETTINGS_SCREEN_IDS.ROOT)];
}

export function createAccountNavigationStack() {
  return [
    ...createRootNavigationStack(),
    createScreen(SETTINGS_SCREEN_IDS.SECTION, { sectionId: "account" }),
  ];
}

export function createTrainingProfileNavigationStack() {
  return [
    ...createRootNavigationStack(),
    createScreen(SETTINGS_SCREEN_IDS.TRAINING_PROFILE_MENU),
  ];
}

export function createInitialNavigationStack(initialScreen) {
  if (initialScreen?.id === SETTINGS_SCREEN_IDS.SECTION) {
    const sectionId = initialScreen?.params?.sectionId;
    if (SETTINGS_SECTION_IDS.has(sectionId)) {
      return [
        ...createRootNavigationStack(),
        createScreen(SETTINGS_SCREEN_IDS.SECTION, { sectionId }),
      ];
    }
  }
  if (initialScreen?.id === SETTINGS_SCREEN_IDS.TRAINING_PROFILE_MENU) {
    return createTrainingProfileNavigationStack();
  }
  return createRootNavigationStack();
}

export function getCurrentScreen(navigationStack) {
  if (!Array.isArray(navigationStack) || navigationStack.length === 0) {
    return createScreen(SETTINGS_SCREEN_IDS.ROOT);
  }

  return navigationStack[navigationStack.length - 1];
}

export function pushScreenEntry(navigationStack, id, params = {}) {
  return [...(navigationStack || createRootNavigationStack()), createScreen(id, params)];
}

export function popScreenEntry(navigationStack) {
  if (!Array.isArray(navigationStack) || navigationStack.length <= 1) {
    return createRootNavigationStack();
  }

  return navigationStack.slice(0, -1);
}

export function isTrainingProfileScreen(screen) {
  return (
    screen?.id === SETTINGS_SCREEN_IDS.TRAINING_PROFILE_MENU ||
    screen?.id === SETTINGS_SCREEN_IDS.TRAINING_PROFILE_SECTION
  );
}
